export const INFINITE_LOOP_PAYLOAD_DEFINITION = {
    definitionParts: []
};
